import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { TripPaymentQuoteCreationRequest, TripPaymentQuoteData, TripPaymentQuoteSearchFilter } from "../../../models/trip-economics.model";

export const tripQuotesSearchSuccess = createAction(
        '[Trip] Trip search quotes success', props<{ searchResult: TripPaymentQuoteData[] }>());

export const tripQuotesSearchRequest = createAction(
        '[Trip] Trip search quotes request', props<{ searchFilter: TripPaymentQuoteSearchFilter }>());

export const tripQuotesSearchFail = createAction(
        '[Trip] Trip search quotes fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripQuotesCreationSuccess = createAction(
        '[Trip] Trip quotes creation success', props<{ tripQuotes: TripPaymentQuoteData[] }>());

export const tripQuotesCreationRequest = createAction(
        '[Trip] Trip quotes creation request', props<{ tripQuotesCreationRequest: TripPaymentQuoteCreationRequest }>());

export const tripQuotesCreationFail = createAction(
        '[Trip] Trip quotes creation fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripQuotesDeleteRequest = createAction(
        '[Trip] Trip quotes delete request', props<{ tripId: number }>());

export const tripQuotesDeleteSuccess = createAction(
        '[Trip] Trip quotes delete success', props<{ tripId: number }>());

export const tripQuotesDeleteFail = createAction(
        '[Trip] Trip quotesdelete fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripQuotesCalculationRequest = createAction(
        '[Trip] Trip quotes calculation request', props<{ totalPrice: number, numberOfQuotes: number, startDate: Date }>());
